import fetchJson from '../lib/react-admin-loopback/fetch';
import { stringify } from 'query-string';
import { getYearMonth, getYearMonthDate } from '../calendar';

export async function reqSettle(supplierId, firstDate) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    queryParams: JSON.stringify({
      yearMonth: getYearMonth(firstDate),
    }),
  };
  const url = `${apiUrl}/suppliers/${supplierId}/settle2?${stringify(params)}`;
  const { json } = await fetchJson(url);
  return {
    data: json,
  };
}

export async function reqPatchMemo(supplierId, date, memo) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/suppliers/${supplierId}/adjust`;
  const options = {
    method: 'PATCH',
    body: JSON.stringify({
      date: getYearMonthDate(date),
      adjustAmount: parseInt(memo.adjust.replaceAll(',', '')),
      adjustMemo: memo.adjustMemo,
    }),
  };
  const { json } = await fetchJson(url, options);
  return {
    data: json,
  };
}

export async function reqSuppliers(page = 1, perPage = 30) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      limit: perPage,
      skip: (page - 1) * perPage,
      order: 'name ASC',
    }),
    clientType: 'bo',
  };
  const url = `${apiUrl}/suppliers?${stringify(params)}`;
  const { headers, json } = await fetchJson(url);
  return {
    data: json,
    total: parseInt(headers.get('content-range').split('/').pop(), 10),
  };
}

export async function searchSuppliers(word, page = 1, perPage = 30) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      limit: perPage,
      skip: 0,
      order: 'name ASC',
      where: { name: `${word}` },
    }),
    clientType: 'bo',
  };

  const url = `${apiUrl}/suppliers?${stringify(params)}`;
  const { headers, json } = await fetchJson(url);

  return {
    data: json,
    total: parseInt(headers.get('content-range').split('/').pop(), 10),
  };
}
